/* eslint no-nested-ternary: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Calendar from 'react-calendar';
import moment from 'moment-timezone';
import {
  Segment,
  Grid,
  Button,
  Transition,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import i18next from 'i18next';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';
import { fromCalendarTile, toCalendarTile } from '../utils/calendarDate';

class CalendarDatePicker extends Component {
  static propTypes = {
    basic: PropTypes.bool,
    closeable: PropTypes.bool,
    closeableCompact: PropTypes.bool,
    maxDate: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.instanceOf(Date),
    ]),
    minDate: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.instanceOf(Date),
    ]),
    noPadding: PropTypes.bool,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.instanceOf(Date),
    ]),
    visible: PropTypes.bool,
    onChange: PropTypes.func,
    t: PropTypes.func.isRequired,
  }
  static defaultProps = {
    visible: true,
    closeable: true,
    closeableCompact: true,
  }
  constructor(props) {
    super(props);
    const date = props.value;
    this.state = {
      date,
      loading: false,
      transition: {
        calendar: true,
        time: false,
      },
      visible: props.visible,
    };
  }
  componentWillReceiveProps(nextProps) {
    const date = nextProps.value;
    this.setState({
      date,
      visible: nextProps.visible,
    });
  }
  setLoading = (loading = false) => {
    this.setState({
      loading,
    });
  }
  handleOnChangeCalendar = (value) => {
    const { date } = this.state;
    const newDate = fromCalendarTile(value, date).toDate();
    // visible to false - close calendar after date selected
    this.setState({ date: newDate, visible: false }, () => {
      if (this.props.onChange) this.props.onChange(newDate, false);
    });
  }
  handleOnClose = (e) => {
    e.preventDefault();
    const { date } = this.state;
    this.setState({ visible: false }, () => {
      if (this.props.onChange) this.props.onChange(date, this.state.visible);
    });
  }
  render() {
    const { date, transition, visible } = this.state;
    const { basic, closeable, closeableCompact, maxDate, minDate, noPadding, t } = this.props;

    const currentLang = i18next.language || 'en-GB';

    return (
      <Transition
        animation={'vertical flip'}
        duration={250}
        transitionOnMount
        unmountOnHide
        visible={visible}
      >
        <Grid centered>
          <Grid.Row style={noPadding && { paddingTop: '0' }}>
            <Grid.Column>
              <Segment basic={basic} className="dtp visible">
                <Transition
                  animation={'scale'}
                  duration={250}
                  unmountOnHide
                  visible={transition.calendar}
                  onComplete={this.setLoading}
                  onHide={this.setLoading}
                >
                  <Segment basic className="dtp_tab_content">
                    <Calendar
                      locale={currentLang}
                      maxDate={maxDate && toCalendarTile(maxDate)}
                      minDate={minDate && toCalendarTile(minDate)}
                      onChange={this.handleOnChangeCalendar}
                      value={toCalendarTile(date || moment())}
                    />
                  </Segment>
                </Transition>
                {closeable && (
                  <Button size="small" primary fluid compact={closeableCompact} onClick={this.handleOnClose}>
                    {t('Close', { ns: TRANSLATION_FILES.translation })}
                  </Button>
                )}
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Transition>
    );
  }
}

// 6. Wrap the export declaration with withTranslation HOC hook
export default withTranslation(namespaces, { withRef: true })(CalendarDatePicker);



// WEBPACK FOOTER //
// ./src/components/CalendarDatePicker.jsx